import { useNavigation } from '@betty/navigation';
import { useEffect } from 'react';
import { useReferrerPromo } from '../hooks';
import { Loader } from '@betty/moonlight';
import ReferrerPromoDetails from '../components/PromoDetails/ReferrerPromoDetails';

function ReferrerPromoScreen() {
  const navigation = useNavigation();
  const { referrerPromo } = useReferrerPromo();

  useEffect(() => {
    if (referrerPromo?.title) {
      navigation.setOptions({ title: referrerPromo?.title });
    }
  }, [navigation, referrerPromo?.title]);

  if (!referrerPromo) {
    return <Loader />;
  }

  return <ReferrerPromoDetails promo={referrerPromo} />;
}

export default ReferrerPromoScreen;
